import _ from 'lodash';
import React from 'react';
import i18next from 'i18next';
import CalculatorSelectInput from '../../../../calculatorInputs/CalculatorSelectInput';
import CalculatorMultipleValueInput from '../../../../calculatorInputs/CalculatorMultipleValueInput';

const SetValue = ({ fieldName, showLabel, availableValueOptions }) => {
  const label = showLabel ? i18next.t('calculator.dialog.create.label.values') : '';
  const placeholder = i18next.t('calculator.dialog.create.placeholder.selectValues');

  const validate = () => {
    // TODO: Implement validation
    return null;
  };

  const commonProps = {
    fieldName: `${fieldName}${_.isEmpty(availableValueOptions) ? '' : '.0'}`,
    label,
    placeholder,
    isRequired: true,
    uxVariant: 'criteriaInput',
    validate,
  };

  return !_.isEmpty(availableValueOptions) ? (
    <CalculatorSelectInput
      {...commonProps}
      options={availableValueOptions}
      variant="standard"
      labelVariant="chip"
      triggerOnContinue
    />
  ) : (
    <CalculatorMultipleValueInput {...commonProps} triggerOnContinue />
  );
};

export default SetValue;
